/** Sticky checkout footer — above sidebar rails, below modal masks. */
export const SUMMARY_FOOTER_Z_INDEX = 120;

/**
 * @param {unknown} nextStageDisabled
 * @returns {boolean}
 */
export function isSummaryFooterButtonDisabled(nextStageDisabled) {
  return Boolean(nextStageDisabled);
}

/**
 * Disabled tooltip / dev trace reason (string) when blocked; empty when enabled.
 * @param {unknown} nextStageDisabled
 * @returns {string}
 */
export function summaryFooterDisabledReason(nextStageDisabled) {
  if (nextStageDisabled == null || nextStageDisabled === false) return "";
  if (typeof nextStageDisabled === "string") return nextStageDisabled.trim();
  return "disabled";
}

/**
 * Whether footer should render payment / navigation CTAs (not loading, not sidebar-only public offer).
 * @param {{
 *   loading?: boolean,
 *   isCustomerLink?: boolean,
 *   showFooterCustomerNav?: boolean,
 * }} input
 */
export function resolveSummaryFooterShowsActions(input = {}) {
  const { loading = false, isCustomerLink = false, showFooterCustomerNav = true } = input;
  if (loading) return false;
  if (isCustomerLink && !showFooterCustomerNav) return false;
  return true;
}

/**
 * @param {object} payload
 */
export function logSummaryFooterDisabledTrace(payload) {
  if (!import.meta.env?.DEV || !payload) return;
  // eslint-disable-next-line no-console
  console.info("[SUMMARY_FOOTER_BUTTON_DISABLED]", payload);
}

/**
 * Dev helper: top element at a point should be the button or inside the footer actions.
 * @param {HTMLElement|null|undefined} buttonEl
 * @returns {{ ok: boolean, topTag: string|null, topClass: string|null }}
 */
export function probeSummaryFooterButtonHitTarget(buttonEl) {
  if (typeof document === "undefined" || !buttonEl?.getBoundingClientRect) {
    return { ok: false, topTag: null, topClass: null };
  }
  const rect = buttonEl.getBoundingClientRect();
  const x = rect.left + rect.width / 2;
  const y = rect.top + rect.height / 2;
  const top = document.elementFromPoint(x, y);
  if (!top) return { ok: false, topTag: null, topClass: null };
  const ok =
    top === buttonEl ||
    buttonEl.contains(top) ||
    top.closest?.("[data-testid='summary-footer-actions']") != null;
  return {
    ok,
    topTag: top.tagName?.toLowerCase?.() ?? null,
    topClass: typeof top.className === "string" ? top.className.split(" ")[0] : null,
  };
}
